import React from "react";

const AddTextField = ({ onAddTextField }) => {
  return (
    <div className="add-textfield__container">
      <button
        className="button button--link button--add-textfield"
        onClick={onAddTextField}
      >
        +<span>add new text field</span>
      </button>
    </div>
  );
};

export default AddTextField;
